import TContext from "./TContext";
import IUIItem from "../interface/IUIItem";

/**
 *
 *
 * @interface IPanelContext
 */
export interface IPanelContext {
    manager: any;
    renderUIItem: (uiItem: IUIItem, props?: any, parent?: IUIItem) => any;
    theme: any;
    updateTheme?: any;
    getUI: (ui: string) => any;
    isEdit?: boolean;
}

const PanelContext = new TContext<IPanelContext>({
    renderUIItem: (uiItem: IUIItem) => {
        return null;
    },
    theme: {},
    manager: null,
    getUI: (ui: string) => { },
    isEdit: false
});

export default PanelContext;
